import moment from 'moment';

//Histórico de valores de contrato (client_contract_values). Cada linha tem só o início de vigência:
//o valor vale até o próximo start_date do mesmo cliente. start_date chega do servidor como
//'YYYY-MM-DD'; tudo aqui é comparado em UTC para não depender do fuso do navegador.

function toUtcDay(date) {
    return moment.utc(date, [moment.ISO_8601, 'DD/MM/YYYY']).startOf('day');
}

/**
 * Linha vigente numa data: a de maior start_date <= date. null se nenhuma começou até lá.
 * @param {Array<{start_date: string, contract_value: string|number}>} rows
 * @param {string|Date|moment.Moment} date
 */
export function getContractValueRowAt(rows, date) {
    const reference = toUtcDay(date);
    let current = null;
    (rows || []).forEach(row => {
        const start = toUtcDay(row.start_date);
        if (start.isAfter(reference)) return;
        if (!current || start.isAfter(toUtcDay(current.start_date))) {
            current = row;
        }
    });
    return current;
}

/**
 * Valor vigente numa data, como número. null se não houver valor vigente.
 */
export function getContractValueAt(rows, date) {
    const row = getContractValueRowAt(rows, date);
    return row ? parseFloat(row.contract_value) : null;
}

/**
 * Custo de contrato do período, mês a mês. O valor de cada mês é o vigente no último dia do mês,
 * então um reajuste que começa no meio do mês já vale para ele; meses anteriores ao primeiro
 * registro não entram. Meses consecutivos de mesmo valor são agrupados num segmento.
 * @param {Array} rows
 * @param {string} startDate - DD/MM/YYYY ou YYYY-MM-DD
 * @param {string} endDate - DD/MM/YYYY ou YYYY-MM-DD
 * @returns {Array<{monthly_value: number, months: number, total: number, from: string, to: string}>}
 *          from/to no formato MM/YYYY
 */
export function buildContractCostsByMonth(rows, startDate, endDate) {
    const segments = [];
    const month = toUtcDay(startDate).startOf('month');
    const lastMonth = toUtcDay(endDate).startOf('month');

    while (!month.isAfter(lastMonth)) {
        const value = getContractValueAt(rows, month.clone().endOf('month'));
        const label = month.format('MM/YYYY');

        if (value !== null && value > 0) {
            const last = segments[segments.length - 1];
            //Só agrupa se o segmento anterior terminou exatamente no mês anterior
            const previousLabel = month.clone().subtract(1, 'month').format('MM/YYYY');
            if (last && last.monthly_value === value && last.to === previousLabel) {
                last.months += 1;
                last.total = last.monthly_value * last.months;
                last.to = label;
            } else {
                segments.push({ monthly_value: value, months: 1, total: value, from: label, to: label });
            }
        }

        month.add(1, 'month');
    }

    return segments;
}
